import { useState, useEffect, useContext, useCallback } from "react";
import axios from "../../context/AxiosInstance";
import { AuthContext } from "../../context/AuthContext";

export const MOIS_LIST = [
  { label: "Tous les mois", value: "all" },
  { label: "Janvier", value: "Janvier" },
  { label: "Février", value: "Février" },
  { label: "Mars", value: "Mars" },
  { label: "Avril", value: "Avril" },
  { label: "Mai", value: "Mai" },
  { label: "Juin", value: "Juin" },
  { label: "Juillet", value: "Juillet" },
  { label: "Août", value: "Août" },
  { label: "Septembre", value: "Septembre" },
  { label: "Octobre", value: "Octobre" },
  { label: "Novembre", value: "Novembre" },
  { label: "Décembre", value: "Décembre" },
];

export const ANNEES_LIST = [
  { label: "Toutes les années", value: "all" },
  { label: "2024", value: "2024" },
  { label: "2025", value: "2025" },
  { label: "2026", value: "2026" },
];

export const JOURS_RECENTS_LIST = [
  { label: "Tous les jours", value: 0 },
  { label: "7 derniers jours", value: 7 },
  { label: "30 derniers jours", value: 30 },
  { label: "90 derniers jours", value: 90 },
];

export function useStatsDashboard() {
  const { token } = useContext(AuthContext);
  const [annee, setAnnee] = useState("2025");
  const [mois, setMois] = useState("all");
  const [joursRecents, setJoursRecents] = useState(30);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboard = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get("/statistiques/dashboard", {
        headers: { Authorization: `Bearer ${token}` },
        params: { annee, mois, jours_recents: joursRecents },
      });
      setData(res.data.data);
    } catch (err) {
      setError("Impossible de charger les statistiques.");
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [token, annee, mois, joursRecents]);

  useEffect(() => {
    const t = setTimeout(fetchDashboard, 200);
    return () => clearTimeout(t);
  }, [fetchDashboard]);

  return {
    annee,
    setAnnee,
    mois,
    setMois,
    joursRecents,
    setJoursRecents,
    data,
    loading,
    error,
    refresh: fetchDashboard,
  };
}
